__turbopack_context__.v({
  "buttons": "SwiperSlider-module-scss-module__WlOzfa__buttons",
  "buttons__nextButton": "SwiperSlider-module-scss-module__WlOzfa__buttons__nextButton",
  "buttons__prevButton": "SwiperSlider-module-scss-module__WlOzfa__buttons__prevButton",
  "slide": "SwiperSlider-module-scss-module__WlOzfa__slide",
  "slider": "SwiperSlider-module-scss-module__WlOzfa__slider",
});
